import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../../types'
import { CmsConverterService } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class AccordionItemPimReferencesConverter extends CmsConverterService<AccordionItemPimReferencesData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const ACCORDION_ITEM_PIM_REFERENCES_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, AccordionItemPimReferencesData>>('AccordionItemPimReferencesConverter')

export type AccordionItemPimReferencesData = ConvertedComponentData
